"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _set2 = _interopRequireDefault(require("lodash/set"));
var _unset2 = _interopRequireDefault(require("lodash/unset"));
var _index = require("../../helpers/index.js");
var _index2 = require("../../templates/product/utils/index.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var SUBCATEGORY_CORE_PRODUCT = _index2.productValuesConstants.SUBCATEGORY_CORE_PRODUCT;
var listField = _index.formatters.listField;
var setCoreProducts = function setCoreProducts(event) {
  var addCoreProducts = event.xdm.web.webPageDetails._telus.addCoreProducts;
  (0, _unset2["default"])(event, 'xdm.web.webPageDetails._telus.addCoreProducts');
  if (!addCoreProducts) return event;
  var products = event.xdm.productListItems;
  if (!products) return event;
  var coreProducts = products.filter(function (_ref) {
    var _ref$_telus = _ref._telus,
      subCategory = _ref$_telus.subCategory,
      contractLength = _ref$_telus.contractLength,
      productName = _ref$_telus.productName;
    return subCategory === SUBCATEGORY_CORE_PRODUCT && !!contractLength && !!productName;
  });
  if (!coreProducts.length) return event;
  var coreProductsValue = listField(coreProducts.map(function (_ref2) {
    var _ref2$_telus = _ref2._telus,
      contractLength = _ref2$_telus.contractLength,
      productName = _ref2$_telus.productName;
    return "".concat(productName, "-").concat(contractLength);
  }), {
    separator: '|',
    shouldSort: true
  });
  (0, _set2["default"])(event, 'xdm.web.webPageDetails._telus.coreProducts', coreProductsValue);
  return event;
};
var _default = exports["default"] = setCoreProducts;